import React from 'react';
import type { Alert } from '../types';

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>;
// FIX: Changed component definition from a const arrow function to a standard function declaration
// to resolve a "not callable" error, likely related to how the build tool handles component definitions.
function ExternalLinkIcon() {
    return (<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>);
}


interface AlertDetailsModalProps {
    alert: Alert;
    onClose: () => void;
}

const AlertDetailsModal: React.FC<AlertDetailsModalProps> = ({ alert, onClose }) => {

    const sourceColors: { [key: string]: string } = {
        FDA: 'bg-blue-600/20 text-blue-300 border-blue-500/30',
        CDC: 'bg-green-600/20 text-green-300 border-green-500/30',
        DEA: 'bg-gray-600/20 text-gray-300 border-gray-500/30',
        'State BOP': 'bg-indigo-600/20 text-indigo-300 border-indigo-500/30',
        'State DOH': 'bg-teal-600/20 text-teal-300 border-teal-500/30',
    };
    
    const severityColors: { [key: string]: string } = {
        High: 'text-red-400',
        Medium: 'text-yellow-400',
        Low: 'text-green-400',
    };

    return (
        <div onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center p-4 z-50 modal-enter" role="dialog" aria-modal="true">
            <div onClick={(e) => e.stopPropagation()} className="bg-gradient-to-br from-[#1a2a47] to-[#15243E] rounded-2xl border border-blue-900/50 w-full max-w-2xl text-gray-300 shadow-2xl flex flex-col max-h-[90vh]">
                <header className="p-6 border-b border-blue-900/50 flex justify-between items-start gap-4">
                    <div>
                        <h2 className="text-2xl font-bold text-white">{alert.title}</h2>
                        <div className="flex items-center gap-2 mt-2 text-xs">
                           <span className={`px-2 py-1 font-bold rounded-md border ${sourceColors[alert.source] || 'bg-gray-500/20 text-gray-300 border-gray-500/30'}`}>{alert.source}</span>
                           <span className={`font-bold ${severityColors[alert.severity] || 'text-gray-400'}`}>{alert.severity} Severity</span>
                           <span className="text-gray-500">•</span>
                           <span className="text-gray-400">Issued: {new Date(alert.date).toLocaleDateString()}</span>
                        </div>
                    </div>
                    <button onClick={onClose} className="text-gray-500 hover:text-white flex-shrink-0"><CloseIcon /></button>
                </header>

                <main className="p-6 overflow-y-auto">
                     <div className="prose prose-invert max-w-none prose-p:text-gray-300">
                        <h4>Summary</h4>
                        <p>{alert.summary}</p>
                        <h4>Details</h4>
                        <p>{alert.details}</p>
                    </div>
                </main>

                <footer className="p-4 border-t border-blue-900/50 mt-auto flex justify-between items-center flex-shrink-0">
                     <button onClick={onClose} className="px-6 py-2 rounded-lg text-gray-300 font-semibold hover:bg-white/10 transition-colors">Close</button>
                    <a href={alert.link} target="_blank" rel="noopener noreferrer" className="bg-yellow-400 text-gray-900 font-bold py-2 px-6 rounded-lg hover:bg-yellow-300 transition-transform hover:scale-105 inline-flex items-center gap-2">
                        View Official Source <ExternalLinkIcon />
                    </a>
                </footer>
            </div>
        </div>
    );
};

export default AlertDetailsModal;